import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col mt-1" }
const _hoisted_2 = { class: "w-full h-full" }
const _hoisted_3 = { class: "flex items-center h-full" }
const _hoisted_4 = { class: "text-center flex-1" }
const _hoisted_5 = { class: "flex items-center" }

import { ref, watch } from 'vue'
import ArrowIcon from '@/assets/icons/down.vue'
import EditIcon from '@/assets/icons/edit.vue'
import DeleteIcon from '@/assets/icons/delete.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditableItemMenu',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "edit", "rename", "deactivate"],
  setup(__props: any, { emit }) {

const props = __props;





const isEditing = ref(false)
const position = ref(props.modelValue)

watch(
  () => props.modelValue,
  (val) => {
    position.value = val
  }
)

const editPosition = () => {
  emit('edit')
  emit('update:modelValue', position.value)
  isEditing.value = false
}

const handleMenuAction = (index: number) => {
  if (index === 0) {
    isEditing.value = true
    emit('rename', position.value)
  } else {
    emit('deactivate')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_menu, null, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("button", _mergeProps(props, { class: "bg-[#D6EEF5] text-black text-sm font-light px-4 py-3 rounded-md w-full h-full min-h-[48px] flex items-center justify-between" }), [
              _createElementVNode("span", _hoisted_4, _toDisplayString(position.value), 1),
              _createVNode(ArrowIcon, { class: "w-4 h-4 shrink-0" })
            ], 16)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, { density: "compact" }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Renomear', 'Desativar'], (item, index) => {
                  return _createVNode(_component_v_list_item, {
                    key: index,
                    value: item,
                    onClick: ($event: any) => (handleMenuAction(index))
                  }, {
                    append: _withCtx(() => [
                      (index === 0)
                        ? (_openBlock(), _createBlock(EditIcon, { key: 0 }))
                        : (_openBlock(), _createBlock(DeleteIcon, { key: 1 }))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["value", "onClick"])
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, !isEditing.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_text_field, {
          modelValue: position.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((position).value = $event)),
          label: "Nome da Posição*",
          variant: "outlined",
          color: "primary20",
          "hide-details": "",
          density: "compact"
        }, {
          "append-inner": _withCtx(() => [
            _createVNode(EditIcon, {
              class: "cursor-pointer",
              onClick: editPosition
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, isEditing.value]
      ])
    ])
  ]))
}
}

})